import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import {
  Typography,
  Grid,
  TextField,
  Button,
  Card,
  CardHeader,
  CardContent,
  FormControlLabel,
  Checkbox,
  FormControl,
  Select,
} from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";


function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const LabTestListFormData = ({
  errorObject,
  addProductForm,
  formData,
  handleChange,
  handleCheck,
  handleReset,
  handleSubmit,
  handleUpdate,
  setFormData,
  ...props
}) => {

  //get DispensingLanguage
const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
const lan = localStorage.getItem('LangCode');
const menukey = "lab-test-list";

  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = useState(0);
  const { t, i18n } = useTranslation();

  function tabChangeHandler(event, newValue) {
    setValue(newValue);
  }

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const FlevelListList = JSON.parse(localStorage.getItem("FTypeList"));
  const Unitofmeasurelist = JSON.parse(localStorage.getItem("Unitofmeasurelist"));


  
   //====== Start Choosen Dropdown===========
   const [chosenValues, setChosenValues] = useState({
    "UnitId": {"id": "","name": ""}
  });

useEffect(() => {
  let chosenValuesData = { ...chosenValues};
  chosenValuesData['UnitId'] = (Unitofmeasurelist.find(Unitofmeasurelist_list => Unitofmeasurelist_list.id == formData.UnitId) ?? null); 

  setChosenValues(chosenValuesData); 

}, [formData.UnitId]);

const handleChangeChoosen = (name, valueobj, value) => {
  let chosenValuesData = { ...chosenValues};
  chosenValuesData[name] = valueobj;   
  setChosenValues(chosenValuesData); 
  props.handleChangeChoosenProps(name, value);
};

//====== End Choosen Dropdown===========


  /* const [getFlevel, setFlevel] = useState([]);

   //let tmp = null;

  useEffect(() => {
    console.log(formData.FTypeIds);
  if(formData.FTypeIds){
      let tmps = formData.FTypeIds;
      console.log('just checking',tmps);
      if (tmps != "") {
        let tmpFLevelIds = tmps.split(',');
        let myArray = [];
        for (let i = 0; i < tmpFLevelIds.length; i++) {
          const tmparrayobject = FlevelListList[FlevelListList.findIndex(FlevelLis_tList => FlevelLis_tList.id == tmpFLevelIds[i])];
          myArray.push(tmparrayobject);
        }
        setFlevel(myArray);

      }
 }

  }, [formData.TestName]); */



  /* const changeHandler = (val) => {
    setFlevel(val);
    let FLevelId = "";
    for (let i = 0; i < val.length; i++) {
      if (FLevelId == "") {
        FLevelId = val[i].id;
      } else {
        FLevelId = FLevelId + "," + val[i].id;
      }

    }

    if (FLevelId != "") {
      formData.FTypeIds = FLevelId;
    } else {
      formData.FTypeIds = "";
    }


  }; */



  const [checkedFormData, setCheckedFormData] = useState({ FTypeIds: [] });

  // Initialize checkedFormData.FTypeIds only if formData.FTypeIds has data
  useEffect(() => {
    if (formData.FTypeIds) {
      setCheckedFormData({ FTypeIds: formData.FTypeIds.split(",") });
    }
  }, [formData.FTypeIds]);


  const handleCheckType = (e) => {
    const { value, checked } = e.target;
    setCheckedFormData((prevCheckedFormData) => {
      if (checked) {
        return {
          ...prevCheckedFormData,
          FTypeIds: [...prevCheckedFormData.FTypeIds, value],
        };
      } else {
        return {
          ...prevCheckedFormData,
          FTypeIds: prevCheckedFormData.FTypeIds.filter((id) => id !== value),
        };
      }
    });

    // Update the formData state with the new FTypeIds
    const updatedFTypeIds = checked
      ? [...checkedFormData.FTypeIds, value]
      : checkedFormData.FTypeIds.filter((id) => id !== value);

    // Convert the array back to a comma-separated string and update the formData state
    setFormData((prevFormData) => ({
      ...prevFormData,
      FTypeIds: updatedFTypeIds.join(","),
    }));
  };


  return (
    <div className={classes.productPageTitle}>
      <div className="sw_makeStyles_tableContainer">
        <div className="d-flex justify-product mb-3">
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading text-center">
              <div className="sw_heading_title_inner">{DispensingLanguage[lan][menukey]['Lab Test List Form - Add/Edit']}</div>
            </div>
          </Grid>
        </div>

        {/* New row */}
        <Grid container spacing={2}>
          {/* New row */}
          <Grid item xs={12} sm={12}>
            <Card className="sw_card">
              <CardHeader title={DispensingLanguage[lan][menukey]['Lab Test List']} />
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={4} sm={12}>
                    <Grid container spacing={4}>
					
                      <Grid item xs={12} sm={6}>
                        <TextField variant="standard"
                          disabled={!!props.permissionType}
                          error={!!errorObject.TestName}
                          helperText={errorObject.TestName}
                          required
                          id="TestName"
                          name="TestName"
                          label= {DispensingLanguage[lan][menukey]['Lab Test Name']}
                          value={formData.TestName}
                          fullWidth
                          autoComplete="family-name"
                          onChange={(e) => handleChange(e)}
                        />
                      </Grid>


                      <Grid item xs={12} sm={3}>

                        <TextField variant="standard"
                            disabled={!!props.permissionType}
                            error={!!errorObject.UnitName}
                            helperText={errorObject.UnitName}
                            //required
                            id="UnitName"
                            name="UnitName"
                            label= {DispensingLanguage[lan][menukey]['Test Unit']}
                            value={formData.UnitName}
                            fullWidth
                            autoComplete="family-name"
                            onChange={(e) => handleChange(e)}
                          />


                          {/* <FormControl className={classes.fullWidth}>
                              <Autocomplete
                              autoHighlight
                              id="UnitId"
                              options={Unitofmeasurelist}
                              onChange={(event, valueobj) => handleChangeChoosen('UnitId', valueobj, valueobj?valueobj.id:"")}
                              getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                              value={chosenValues['UnitId']}
                              renderOption={(props, option) => (
                              <li {...props} key={option.id ?? option.name}>
                                <Typography className="sw_fontSize">{option.name}</Typography>
                              </li>
                              )}
                              renderInput={(params) => (
                              <TextField
                                {...params}
                                value={formData.UnitId}
                                label={DispensingLanguage[lan][menukey]["Test Unit"]+ " *"}
                                variant="standard"
                                error={!!errorObject.UnitId}
                                helperText={errorObject.UnitId}
                                id="UnitId"
                                name="UnitId"
                                fullWidth
                              />
                              )}
                              />

                          </FormControl> */}
                      </Grid>
					  
                   
                      <Grid item xs={12} sm={1}>
                         <FormControl component="fieldset">
                          <FormControlLabel 
                            control={
                              <Checkbox
                                disabled={!!props.permissionType}
                                color="primary"
                                checked={formData.IsCD4}
                                onChange={(e) => handleCheck(e)}
                                name="IsCD4"
                                value="no"
                              />
                            }
                            label={DispensingLanguage[lan][menukey]["Is CD4"]}
                          />
                        </FormControl>
                    </Grid>
					  
                   

                      <Grid item xs={12} sm={2}>
                        <FormControl component="fieldset">
                          <FormControlLabel
                            control={
                              <Checkbox
                                disabled={!!props.permissionType}
                                color="primary"
                                checked={formData.IsVirale}
                                onChange={(e) => handleCheck(e)}
                                name="IsVirale"
                                value="no"
                              />
                            }
                            label={DispensingLanguage[lan][menukey]["Is Charge Virale"]}
                          />

                        </FormControl>
                    </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} sm={12}>
                        <Grid container spacing={4}>
                  <Grid item xs={12} sm={9}>

                    <TextField variant="standard"
                      disabled={!!props.permissionType}
                      error={!!errorObject.TestSettings}
                      helperText={errorObject.TestSettings}
                      required
                      id="TestSettings"
                      name="TestSettings"
                      label= {DispensingLanguage[lan][menukey]['Result Type']}
                      value={formData.TestSettings}
                      fullWidth
                      autoComplete="family-name"
                      onChange={(e) => handleChange(e)}
                      />

                    </Grid>

                    
                    <Grid item xs={12} sm={3}>
                         <FormControl component="fieldset">
                          <FormControlLabel 
                            control={
                              <Checkbox
                                disabled={!!props.permissionType}
                                color="primary"
                                checked={formData.PaquetMinimum}
                                onChange={(e) => handleCheck(e)}
                                name="PaquetMinimum"
                                value="no"
                              />
                            }
                            label={DispensingLanguage[lan][menukey]["Paquet Minimum"]}
                          />
                        </FormControl>
                    </Grid>


                    </Grid>  
                    </Grid>

                    <Grid item xs={12} sm={12}>
                        <Grid container spacing={4}>

                              <Grid item xs={12} sm={12}>
                                  <Grid container>
                                      <Grid item xs={12} sm={12}>
                                        <Typography className="MuiInputBase-input">{DispensingLanguage[lan][menukey]["Facility Type"]}:</Typography>
                                          {FlevelListList.map((item) => (
                                              <FormControl className="checkBoxCustomdynamic" component="fieldset" key={item.id}>
                                                <FormControlLabel
                                                  control={
                                                    <Checkbox
                                                      disabled={!!props.permissionType}
                                                      color="primary"
                                                      checked={checkedFormData.FTypeIds.includes(String(item.id))}
                                                      onChange={handleCheckType}
                                                      name={item.name}
                                                      value={String(item.id)}
                                                    />
                                                  }
                                                  label={item.name}
                                                />
                                              </FormControl>
                                          
                                          ))}

                                        </Grid>
                                      </Grid>
                              </Grid>
                          </Grid>
                    </Grid>



                </Grid>
              </CardContent>
            </Card>
          </Grid>

          {/* Action buttons */}
          {addProductForm ? (
            <Grid item xs={12} className="mt-4 text-center">
              <Button
                disabled={!!props.permissionType}
                className="me-2"
                variant="contained"
                color="gray"
                type="reset"
                onClick={() => handleReset()}
              >
                {t(DispensingLanguage[lan][menukey]['Reset'])}
              </Button>
              <Button
                disabled={!!props.permissionType}
                className="me-2"
                variant="contained"
                color="primary"
                onClick={() => handleSubmit()}
              >
                {t(DispensingLanguage[lan][menukey]['Save'] )}
              </Button>
              <Button
                className="me-2"
                variant="contained"
                color="gray"
                type="reset"
                onClick={() => props.history.push("/lab-test-list")}
              >
                {t(DispensingLanguage[lan][menukey]['Cancel'] )}
              </Button>
            </Grid>
          ) : (
            <Grid item xs={12} className="mt-2 text-center">
              <Button
                disabled={!!props.permissionType}
                className="me-2"
                variant="contained"
                color="primary"
                onClick={() => handleUpdate()}
              >
                {t(DispensingLanguage[lan][menukey]['update'] )}
              </Button>
              <Button
                className="me-2"
                variant="contained"
                color="gray"
                type="reset"
                onClick={() => props.history.push("/lab-test-list")}
              >
                {t( DispensingLanguage[lan][menukey]['Cancel'])}
              </Button>
            </Grid>
          )}
          
        </Grid>
      </div>
    </div>
  );
};

export default LabTestListFormData;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
});
